const e=({palette:r,vars:o})=>({styleOverrides:{root:{backgroundColor:((o==null?void 0:o.palette)||r).primary.main,fontWeight:"600"},rounded:{borderRadius:8}}});export{e as default};
